import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  serviceRadioButtons: {
    '& .MuiTypography-root:not(.radioAmount)': {
      display: '-webkit-box',
      '-webkit-line-clamp': 3,
      '-webkit-box-orient': 'vertical',
      whiteSpace: 'normal',
    },
  },
  from: {
    justifyContent: 'end',
    width: '70%',
    display: 'flex',
    maxWidth: theme.spacing(51.5),
  },
  label: {
    color: theme.palette.neutral.dark,
    ...theme.typography.inputText,
  },
}))

export default useStyles
